var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    fill: "white",
    stroke: "#DCF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5632 32.8898V40.5838L35.0002 27.1679L25.5632 32.8898ZM34.6391 24.6844L25.5632 9.41797V20.5208L34.6391 24.6844ZM25.5632 21.3973V30.8688L34.5669 25.5366L25.5632 21.3973ZM15.6928 24.6844L24.7687 9.41797V20.5208L15.6928 24.6844ZM24.7687 21.3973V30.8688L15.7409 25.5366L24.7687 21.3973ZM24.7446 32.8898V40.5838L15.3076 27.1679L24.7446 32.8898Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.b787769f3ad6cc2270e47772e3b8057b.svg";
export { ForwardRef as ReactComponent };